import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import OneOnOneTimeIndicator from '../../oneOnOneTimeIndicator';
import UserLink from '../../userLink';
import CustomButton from '../../customButton';
import { ReactComponent as CalendarIcon } from '../../../../assets/icons/event_note.svg';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    marginRight: spacing(2),
  },
  user: {
    margin: spacing(2, 0),
  },
  requestedOnWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  calendarIcon: {
    marginTop: spacing(-1),
    marginRight: spacing(2),
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 'auto',
  },
  acceptButton: {
    marginLeft: spacing(-2),
  },
  dismissButton: {
    color: primary.bluish1,
  },
}));

const OneOnOneRequestCard = ({
  translations,
  request = {},
  onAccept,
  onDismiss,
}) => {
  const classes = useStyles();

  const { user, isAccessible, requestedOn } = request;

  const handleAccept = useCallback(() => {
    return onAccept(request.id);
  }, [request, onAccept]);

  const handleDismiss = useCallback(() => {
    onDismiss(request.id);
  }, [request, onDismiss]);

  return (
    <div className={classes.root}>
      <div className={classes.titleWrapper}>
        <Typography className={classes.title} variant="overline">
          {translations.title.toUpperCase()}
        </Typography>
        <OneOnOneTimeIndicator labels={translations.statuses} />
      </div>
      <UserLink
        className={classes.user}
        user={user}
        avatarProps={{
          variant: 'subtitle1',
          extraSmall: false,
          small: true,
        }}
        isUserAccessible={isAccessible}
      />
      <div className={classes.requestedOnWrapper}>
        <CalendarIcon className={classes.calendarIcon} />
        <Typography variant="body2">{`${requestedOn}`}</Typography>
      </div>
      <div className={classes.actions}>
        <CustomButton
          className={classes.acceptButton}
          type="textRoundedSmall"
          onClick={handleAccept}
        >
          {translations.accept}
        </CustomButton>
        <CustomButton
          className={classes.dismissButton}
          type="textRoundedSmall"
          onClick={handleDismiss}
        >
          {translations.dismiss}
        </CustomButton>
      </div>
    </div>
  );
};

OneOnOneRequestCard.propTypes = {
  request: PropTypes.object,
};

export default OneOnOneRequestCard;
